module.exports = __webpack_public_path__ + "28b9f727402aaad70f375fd3617f7bcc.m4a";